import { render, staticRenderFns } from "./AssignTestToEntity.vue?vue&type=template&id=4cf08708&scoped=true&"
import script from "./AssignTestToEntity.vue?vue&type=script&lang=ts&"
export * from "./AssignTestToEntity.vue?vue&type=script&lang=ts&"
import style0 from "./AssignTestToEntity.vue?vue&type=style&index=0&id=4cf08708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf08708",
  null
  
)

export default component.exports